import { z, ZodTypeAny } from 'zod';

import { Option } from '../../types/Option';

const portFeatures = [
    'pre-charge',
    'contactor',
    'arc-fault-detection',
    'circuit-breaker',
    'disconnect',
    'fuse',
    'residual-current-detection',
    'voltage-measurement',
    'current-measurement',
    'power-measurement',
    'energy-measurement',
    'isolation-monitoring',
    'surge-protection',
] as const;

export type PortFeature = (typeof portFeatures)[number];

const options = [
    { value: 'pre-charge', label: 'Pre Charge' },
    { value: 'contactor', label: 'Contactor' },
    { value: 'arc-fault-detection', label: 'Arc Fault Detection' },
    { value: 'circuit-breaker', label: 'Circuit Breaker' },
    { value: 'disconnect', label: 'Disconnect' },
    { value: 'fuse', label: 'Fuse' },
    { value: 'residual-current-detection', label: 'Residual Current Detection' },
    { value: 'voltage-measurement', label: 'Voltage Measurement' },
    { value: 'current-measurement', label: 'Current Measurement' },
    { value: 'power-measurement', label: 'Power Measurement' },
    { value: 'energy-measurement', label: 'Energy Measurement' },
    { value: 'isolation-monitoring', label: 'Isolation monitoring' },
    { value: 'surge-protection', label: 'Surge protection' },
] as Option<PortFeature>[];

const validator = z.array(z.enum(portFeatures)).default([]);

export const PortFeatures = {
    validator,
    options,
};
